import React from "react";
import { F } from "../../../utils/gerencialFields";
import { ETAPA_LABELS } from "../../../utils/toc/etapas";
import { ZONA_LABELS } from "../../../utils/toc/bufferManager";
import {
  CriticosTable,
  CriticosTableWrapper,
  CriticosTd,
  CriticosTh,
  EmptyHint,
  ZONE_TONES,
  ZonePill,
  ZoneSwatch,
} from "./styles";

function formatPct(value) {
  if (value == null || !Number.isFinite(value)) return "—";
  return `${Math.round(value * 100)}%`;
}

export default function TamborTable({ tambor, ccrEtapa, dias }) {
  if (!ccrEtapa) {
    return <EmptyHint>Sem CCR definido — defina nos parâmetros ou aguarde o cálculo do gargalo.</EmptyHint>;
  }
  if (!tambor || tambor.length === 0) {
    return (
      <EmptyHint>
        Nenhum ambiente programado para {ETAPA_LABELS[ccrEtapa]} nos próximos {dias} dias úteis.
      </EmptyHint>
    );
  }

  return (
    <CriticosTableWrapper>
      <CriticosTable>
        <thead>
          <tr>
            <CriticosTh $center>Ordem</CriticosTh>
            <CriticosTh>Pedido</CriticosTh>
            <CriticosTh>Cliente</CriticosTh>
            <CriticosTh>Ambiente</CriticosTh>
            <CriticosTh>Etapa atual</CriticosTh>
            <CriticosTh $center>Pulmão</CriticosTh>
            <CriticosTh $right>% Consumido</CriticosTh>
          </tr>
        </thead>
        <tbody>
          {tambor.map(({ amb, status, etapaAtual }, index) => {
            const tone = ZONE_TONES[status.zona] || "default";
            return (
              <tr key={`${amb?.[F.NUMERO_DO_PEDIDO] || "row"}-${amb?.[F.AMBIENTE] || index}`}>
                <CriticosTd $center>{index + 1}</CriticosTd>
                <CriticosTd>{amb?.[F.NUMERO_DO_PEDIDO] || "—"}</CriticosTd>
                <CriticosTd>{amb?.[F.NOME_DO_CLIENTE] || "—"}</CriticosTd>
                <CriticosTd>{amb?.[F.AMBIENTE] || "—"}</CriticosTd>
                <CriticosTd>{ETAPA_LABELS[etapaAtual] || "—"}</CriticosTd>
                <CriticosTd $center>
                  <ZonePill $tone={tone}>
                    <ZoneSwatch $zone={status.zona} aria-hidden />
                    {ZONA_LABELS[status.zona] || "—"}
                  </ZonePill>
                </CriticosTd>
                <CriticosTd $right>{formatPct(status.pctConsumido)}</CriticosTd>
              </tr>
            );
          })}
        </tbody>
      </CriticosTable>
    </CriticosTableWrapper>
  );
}
